var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{staticClass:"tag",attrs:{"outlined":"","loading":_vm.loading,"value":_vm.content,"auto-grow":"","background-color":"white"}})
}
var staticRenderFns = []

export { render, staticRenderFns }